export default __webpack_public_path__ + "static/media/capital-electric.44990776.png";